module.exports = __webpack_public_path__ + "img/wuyi3.1e352eaf.png";